import { renderBlocks } from "#strapi-blocks-renderer/utils";
export const useBlocksText = (blockNodes) => {
  const textNodes = renderBlocks(blockNodes);
  return {
    text: textNodes
  };
};
